<template>
  <v-card>
    <v-layout column>
      <v-toolbar card dense light flat >
        <v-flex>
          <v-layout row>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
          <v-layout v-show="cxt.isFilterMode() && cxt.isSelectMode()" style="overflow:hidden" justify-end>
          </v-layout>
          <v-flex v-show="cxt.isFilterMode()" sm4 xs4>
            <v-text-field
              autofocus
              label="Фильтр"
              v-show="cxt.isFilterMode()"
              :value="cxt.filterString"
              v-on:input="onChangeFilter"
              solo flat
            ></v-text-field>
          </v-flex>
      </v-toolbar>
      <v-card-scroll ref="cardScroll" :height="calcDialogScroll(48+48+52)" v-on:nextPage="nextPage">
      <v-list
      three-line dense>
        <template v-for="item in this.filteredItems">
          <v-list-tile v-bind:key="item.id" @click.stop="!cxt.isSelectMode() ? openItem(item) : select(item.id)">
            <v-list-tile-content style="justify-content: start">
              <!-- <span style="white-space: normal;"><b>{{item.name}}</b></span> -->
              <v-list-tile-title><b><a :href="getItemRef(item)" target="_blank">{{item.title}}</a></b></v-list-tile-title>
              <v-list-tile-sub-title>
                {{item.description}}
                 <!-- <span style="white-space: normal;">{{item.description}}</span> -->
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text v-show="!cxt.isSelectMode()"> {{formatState(item.state)}} </v-list-tile-action-text>
              <span v-show="cxt.isSelectMode()">
                <v-list-tile-action-text>  {{formatState(item.state)}} </v-list-tile-action-text>
                <v-icon v-if="radio" v-show="cxt.check(item.id + '')">radio_button_checked</v-icon>
                <v-icon v-if="radio" v-show="cxt.uncheck(item.id + '')">radio_button_unchecked</v-icon>
                <v-icon v-if="!radio" v-show="cxt.check(item.id + '')">check_box</v-icon>
                <v-icon v-if="!radio" v-show="cxt.uncheck(item.id + '')">check_box_outline_blank</v-icon>
              </span>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-scroll>
  </v-layout>
  </v-card>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import people from '../people/index.js'
  import vCardScroll from '../common/CardScroll'

  export default {
    name: 'people-selector-tab',
    components: {vCardScroll},
    data: () => ({
      itemId: null,
      cxt: null,
      humans: []
    }),
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => item.id + '')
      })
      cxt.filterMode = true
      cxt.mode = classes.modes.SELECT
      this.cxt = cxt
    },
    mounted () {
      this.cxt.filterString = this.query || this.getItemSet.getFilter().search
      this.itemId = this.queryCxt
      this.fetchData()
    },
    watch: {
      queryCxt (newVal) {
        this.itemId = newVal
        this.fetchItems()
      },
      query (newVal) {
        if (newVal) {
          this.cxt.filterString = newVal
        }
      },
      selected (newVal, oldVal) {
        this.cxt.setSelected(newVal)
      },
      methodsQueue () {
        this.processMethodsQueue()
      }
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      queryCxt: {
        type: String,
        default: null
      },
      query: {
        type: String,
        default: null
      },
      selected: {
        type: Array,
        default: []
      },
      methodsQueue: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient',
        getIsMobile: 'getIsMobile',
        getPeople: 'getPeople',
        getPeopleFilterContext: 'getPeopleFilterContext',
        getPeopleTotal: 'getPeopleTotal',
        calcDialogScroll: 'calcDialogScroll',
        getItemSet: 'getPeopleSet'
      }),
      title () {
        return 'Выберите физическое лицо'
      },
      items () {
        return this.getItemSet.getItems()
      },
      orderedItems () {
        return this.items.sort((a, b) => formats.compareString(a.title, b.title))
      },
      filteredItems () {
        return this.orderedItems
      },
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : ''
        } else {
          return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : ''
        }
      }
    },
    methods: {
      changeFilterContext (ops, force) {
        this.$store.commit('setPeopleFilterContext', Object.assign({}, this.getItemSet.getFilter(), ops))
        var self = this
        setTimeout(() => {
          self.$store.dispatch('fetchPeople', force)
          // self.scrollToActive()
        }, 500)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
        if ((this.getProfileHaveClient)) {
          let search = formats.stringifySearchTerms(formats.parseSearchTerms(this.cxt.filterString))
          if (formats.compareString(search, this.getItemSet.getFilter().search) !== 0) {
            this.changeFilterContext({search: search}, true)
          }
        }
      },
      nextPage () {
        this.$store.commit('nextPeople')
        this.$store.dispatch('fetchPeople')
      },
      fetchData () {
        if (this.getProfileHaveClient) {
          this.changeFilterContext({search: this.cxt.filterString})
        }
      },
      formatState (state) {
        return state
      },
      processMethodsQueue () {
        if (!this.methodsQueue) return
        let len = this.methodsQueue.length
        for (let i = 0; i < len; i++) {
          let method = this.methodsQueue.shift()
          if (this[method.name]) {
            this[method.name](method.params)
          }
        }
      },
      checkAll () {
        this.cxt.checkAll()
        this.$emit('input', this.cxt.selected())
      },
      select (uid) {
        if (this.cxt.uncheck(uid + '')) {
          if (this.radio) {
            this.cxt.clear()
          }
        }
        this.cxt.select(uid + '')
        this.$emit('input', this.cxt.selected())
      },
      openItem (item) {
        people.open(item.id)
      },
      getItemRef (item) {
        return people.getItemRef(item.id)
      }
    }

  }

</script>




// WEBPACK FOOTER //
// PeopleSelectorTab.vue?0bbff8c0